export default __webpack_public_path__ + "static/media/Path 5@2x.b76aa342.png";